import { render } from "./UmbrellaRecommender.vue?vue&type=template&id=b4e4987c"
import script from "./UmbrellaRecommender.vue?vue&type=script&lang=js"
export * from "./UmbrellaRecommender.vue?vue&type=script&lang=js"

import exportComponent from "/Users/haoche/Documents/Parsons/2024 Spring/Major Studio 2/thesis/vue-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__